import tools from '@/sui/data/sheets/edit/tools'
import patient from '@/sui/data/sheets/edit/patient'
import fields from '@/sui/data/sheets/edit/fields'
import { checkAge } from '@/sui/data/sheets/edit/notes/observa4'

import ice from '@/sui/tools/ice'
import assert from '@/sui/tools/assert'
import rtti from '@/sui/tools/rtti'

import go from '@/gojs/go'

const select = (function () {
  const obsManagment =
  function obsManagment (v) {
    assert.notNull(v)
    return tools.equals(fields.obsManagment, v)
  }

  function yes (f) {
    assert.notNull(f)
    return tools.equals(f, 1)
  }

  function no (f) {
    assert.notNull(f)
    return tools.equals(f, 2)
  }

  const result = {
    yes,
    no,
    obs: tools.notNull(fields.obsManagment),

    p1: obsManagment(1),
    p2: obsManagment(2),
    p3: obsManagment(3),
    p4: obsManagment(6),
    p5: obsManagment(8),
    b1: obsManagment(4),
    b2: obsManagment(5),
    r1: obsManagment(7)
  }

  const list = ['p1', 'p2', 'p3', 'p4', 'p5', 'b1', 'b2', 'r1']

  const total = Math.pow(2, list.length)
  for (let i = 0; i !== total; ++i) {
    const keys = []
    const selects = []

    for (let j = 0; j !== list.length; ++j) {
      const key = list[j]
      if (i & (1 << j)) {
        keys.push(key)
        selects.push(result[key])
      }
    }

    if (keys.length > 1) {
      const addKey = keys.join('')
      result[addKey] = tools.oneTrue(...selects)
    }
  }

  return result
})()

const obsManagment = {
  all: tools.cfg.list(
    fields.obsManagment, 'Type de fiche', go.fields2021.obsManagment
  )
}

const place = {
  p1: tools.cfg.list(
    fields.place, 'Lieu de pose', go.fields.place, { sel: select.p1 }
  )
}

const otherPlace = {
  p1: tools.cfg.text(
    fields.otherPlace, 'Préciser le lieu de pose',
    { sel: tools.equals(place.p1.field, 4) }
  )
}

const catheterType = (function () {
  const t = 'Dispositif'
  const f = fields.catheterType

  return {
    p1: tools.cfg.list(
      `p1${f}`, t, go.fields2024.p1Type, { sel: select.p1, srv: f }
    ),

    p2: tools.cfg.list(
      `p2${f}`, t, go.fields2023.p2Type, { sel: select.p2, srv: f }
    ),

    b1: tools.cfg.list(
      `b1${f}`, t, go.fields2023.b1Type, { sel: select.b1, srv: f }
    ),

    b2: tools.cfg.list(
      `b2${f}`, t, go.fields.b2Type, { sel: select.b2, srv: f }
    )
  }
})()

const audited = (function () {
  const t = `Catégorie professionnelle`
  const f = fields.audited

  return {
    p1p3: tools.cfg.list(
      `p1p3p4${f}`, t, go.fields2022.p1p3p4Audited, { sel: select.p1p3p4, srv: f }
    ),

    p2b1b2: tools.cfg.list(
      `p2b1b2${f}`, t, go.fields.p2b1b2Audited, { sel: select.p2b1b2, srv: f }
    )
  }
})()

const student = {
  all: tools.cfg.list(
    fields.student, 'Étudiant', go.fields.yesNo, { sel: select.obs }
  )
}

const auditedCleanOutfit = {
  p2p3b1b2: tools.cfg.list(
    fields.auditedCleanOutfit, `Port d'une tenue propre`, go.fields.yesNo, {
      sel: select.p2p3p4b1b2
    }
  )
}

const sterileGown = {
  p1: tools.cfg.list(
    fields.sterileGown, `Port d'une casaque stérile`, go.fields.yesNo,
    { sel: select.p1 }
  )
}

const auditedCap = {
  p1p3: tools.cfg.list(
    fields.auditedCap, `Port d'une coiffe`, go.fields.yesNo, { sel: select.p1p3r1 }
  )
}

const compliantAuditedCap = {
  p1p3: tools.cfg.list(
    fields.compliantAuditedCap, `Le port de la coiffe est-il conforme ?`,
    go.fields.yesNo, { sel: select.yes(auditedCap.p1p3.field) }
  )
}

const sterileGloves = (function () {
  const t = 'Port des gants stériles'
  const f = fields.sterileGloves

  return {
    p1: tools.cfg.list(
      `p1${f}`, t, go.fields.yesNo, { sel: select.p1, srv: f }
    ),

    b2: tools.cfg.list(
      `b2${f}`, t, go.fields.yesNo, { sel: select.b2, srv: f }
    )
  }
})()

const auditedMask = {
  p1p3b2: tools.cfg.list(
    fields.auditedMask, `Port du masque chirurgical`, go.fields.yesNo,
    { sel: select.p1p3b2r1 }
  )
}

const compliantAuditedMask = {
  p1p3b2: tools.cfg.list(
    fields.compliantAuditedMask, `Le port du masque est-il conforme ?`,
    go.fields.yesNo, { sel: select.yes(auditedMask.p1p3b2.field) }
  )
}

const isAdult = {
  p1p2p3: tools.cfg.list(
    fields.isAdult, 'Adulte', go.fields.yesNo, { sel: select.p1p2p3r1 }
  )
}

const childAge = {
  p1p2p3: tools.cfg.list(
    fields.childAge, `Âge de l'enfant`, go.fields2020.childAge,
    { sel: select.no(isAdult.p1p2p3.field) }
  )
}

const patientCleanOutfit = {
  p1p2p3b2: tools.cfg.list(
    fields.patientCleanOutfit, `Port d'une tenue propre`, go.fields.yesNo,
    { sel: select.p1p2p3p4b2 }
  )
}

const patientMask = {
  p1p3b2: tools.cfg.list(
    fields.patientMask, `Port du masque chirurgical`, go.fields.yesNoSo,
    { sel: select.p1p3b2r1 }
  )
}

const compliantPatientMask = {
  p1p3b2: tools.cfg.list(
    fields.compliantPatientMask, `Le port du masque est-il conforme ?`,
    go.fields.yesNo, { sel: select.yes(patientMask.p1p3b2.field) }
  )
}

const patientSterileField = {
  p1: tools.cfg.list(
    fields.patientSterileField, `Le visage est-il couvert par un champ stérile ?`,
    go.fields.yesNo, {
      sel: tools.allTrue(select.p1r1, select.no(patientMask.p1p3b2.field)) }
  )
}

const patientOtherSide = {
  p3b2: tools.cfg.list(
    fields.patientOtherSide, `Visage tourné du côté opposé et ne parle pas ?`,
    go.fields.yesNo, {
      sel: tools.allTrue(
        tools.oneTrue(select.b2, select.p3, select.r1),
        select.no(patientMask.p1p3b2.field)
      )
    }
  )
}

const patientCap = {
  p1: tools.cfg.list(
    fields.patientCap, `Port d'une coiffe`, go.fields.yesNo,
    { sel: select.p1 }
  )
}

const compliantPatientCap = {
  p1: tools.cfg.list(
    fields.compliantPatientCap, `Le port de la coiffe est-il conforme ?`,
    go.fields.yesNo, { sel: select.yes(patientCap.p1.field) }
  )
}

function buildHandHygiene (s, f, t, i, c, cv) {
  const field = `${fields.handHygiene}${f}`
  return [
    tools.cfg.list(
      field, `Hygiène des mains ${t}`, go.fields.yesNo, { sel: i, srv: s }
    ),

    tools.cfg.list(
      `${field}Type`, c || 'Désinfection des mains', cv, {
        sel: select.yes(field), srv: `${s}Type`
      }
    ),

    tools.cfg.list(
      `${field}Compliant`, `La technique est-elle conforme ?`,
      go.fields.yesNo, {
        sel: select.yes(field), srv: `${s}Compliant`
      }
    )
  ]
}

const handHygieneBeforePreparation = {
  p2p3: buildHandHygiene(
    fields.handHygiene, 'BeforePreparation', 'immédiatement avant la préparation du site',
    select.p2p3p4, null, go.fields.handHygieneTypeSimple
  )
}

const handHygieneBeforeManip = {
  b1: buildHandHygiene(
    fields.handHygiene, 'BeforeManip', 'avant la manipulation', select.b1,
    null, go.fields.handHygieneTypeSimple
  )
}

const handHygieneBeforeGloves = {
  b2: buildHandHygiene(
    fields.handHygiene, 'BeforeGloves', 'avant le port de gants', select.b2,
    null, go.fields.handHygieneTypeSimple
  )
}

const handHygieneBeforeInsertion = {
  p1: buildHandHygiene(
    fields.handHygiene, 'BeforeInsertion', 'avant la pose du dispositif', select.p1,
    'Désinfection chirurgicale des mains', go.fields2022.handHygieneType
  )
}

const handHygieneBeforePeriInsertion = {
  p2: buildHandHygiene(
    fields.secondaryHandHygiene, `BeforePeriInsertion`,
    `immédiatement avant l'insertion du cathéter`,
    select.p2p4, null, go.fields.handHygieneTypeSimple
  )
}

const handHygieneBeforePuncture = {
  p3: buildHandHygiene(
    fields.secondaryHandHygiene, 'BeforePuncture',
    `immédiatement avant la ponction`,
    select.p3, null, go.fields.handHygieneTypeSimple
  )
}

const dirtySkin = {
  p1p2p3: tools.cfg.list(
    fields.dirtySkin, 'Peau nécessitant un nettoyage', go.fields.yesNo,
    { sel: select.p1p2p3p4 }
  )
}

const insertionSiteCleaned = {
  p1p2p3: tools.cfg.list(
    fields.insertionSiteCleaned, `Nettoyage de la zone d'insertion`,
    go.fields.yesNo, { sel: select.p1p2p3p4r1 }
  )
}

function buildAntiseptic (
  fieldPart, title, prefix, selector, values, cfield = true
) {
  const applied = `${prefix}${fieldPart}Applied`
  const product = `${prefix}${fieldPart}`
  const productOther = `${prefix}${fieldPart}Other`
  const result = [
    tools.cfg.list(
      applied, title, go.fields.yesNo, {
        sel: selector,
        srv: cfield ? fields.antisepticApplied : undefined
      }
    ),
    tools.cfg.list(
      product, 'Antiseptique', values, {
        sel: select.yes(applied),
        srv: cfield ? fields.antiseptic : undefined
      }
    ),
    tools.cfg.text(
      productOther,
      `Préciser l'antiseptique (Ajouter la mention «Alcoolique» si l'antiseptique est alcoolique)`, {
        sel: tools.equals(product, 10),
        srv: cfield ? fields.otherAntiseptic : undefined
      }
    )
  ]
  return result
}

const antiseptic = (function () {
  const application = `Application d'un antiseptique (ASQ)`
  const impregnation = `Imprégnation des compresses avec un antiseptique (ASQ)`

  return {
    p1p2p3: buildAntiseptic(
      'Antiseptic', application, 'p1p2p3p4', select.p1p2p3p4, go.fields.antiseptic
    ),

    b1: buildAntiseptic(
      'CompressAntiseptic', impregnation, 'b1', select.b1, go.fields.antiseptic
    ),

    b2: buildAntiseptic(
      'CompressAntiseptic', impregnation, 'b2', select.b2, go.fields.antisepticNo7
    )
  }
})()

const sterileCompresses = (function () {
  const t = 'Compresses stériles'
  const f = 'SterileCompresses'

  return {
    p1p2p3: tools.cfg.list(
      `p1p2p3${f}`, t, go.fields.yesNoSo, {
        sel: tools.allTrue(select.p1p2p3, select.yes(antiseptic.p1p2p3[0].field)),
        srv: fields.sterileCompresses
      }
    ),

    b1b2: tools.cfg.list(
      `b1b2${f}`, t, go.fields.yesNo, {
        sel: select.b1b2, srv: fields.sterileCompresses
      }
    )
  }
})()

const valve = {
  b1b2: tools.cfg.list(
    fields.valve, `Présence d'une valve bidirectionnelle`,
    go.fields.yesNo, { sel: select.b1b2 }
  )
}

const valveAntiseptic = (function () {
  const desinfection = 'Désinfection de la valve avant utilisation'
  return {
    b1b2: buildAntiseptic(
      'Antiseptic', desinfection, 'valve',
      select.yes(valve.b1b2.field), go.fields.antisepticNo7,
      false
    )
  }
})()

const antisepticPassages = {
  p1p2p3: tools.cfg.numeric(
    fields.antisepticPassages, `Nombre de passages de l'antiseptique`, 1,
    {
      un: 'passage·s',
      sel: tools.allTrue(select.p1p2p3, select.yes(antiseptic.p1p2p3[0].field))
    }
  )
}

const dry = {
  p1p2p3: tools.cfg.list(
    fields.dry, `Séchage spontané sans essuyage de l'antiseptique`,
    go.fields.yesNo, {
      sel: tools.allTrue(select.p1p2p3p4, select.yes(antiseptic.p1p2p3[0].field)),
      ctx: function (sheet) {
        assert(select.p1p2p3p4(sheet, sheet))
        const suffix = select.p3(sheet, sheet)
          ? `avant la ponction`
          : `avant l'insertion du cathéter`
        return {
          title: `Séchage spontané de l'antiseptique ${suffix}`
        }
      }
    }
  )
}

const gloves = {
  p2p3b1: tools.cfg.list(
    fields.gloves, `Port de gants`, go.fields.yesNo, { sel: select.p2p3b1 }
  )
}

const glovesType = {
  p2p3: tools.cfg.list(
    fields.glovesType, `Type de gants`, go.fields.gloves,
    { sel: tools.allTrue(select.p2p3, select.yes(gloves.p2p3b1.field)) }
  )
}

const glovesJustified = {
  b1: tools.cfg.list(
    fields.glovesJustified, `Le port des gants est-il justifié ?`,
    go.fields.yesNo, { sel: tools.allTrue(select.b1, select.yes(gloves.p2p3b1.field)) }
  )
}

const palpation = {
  p2: tools.cfg.list(
    fields.palpation, `Palpation du site d'insertion après l'antisepsie`,
    go.fields.yesNo, { sel: select.p2 }
  )
}

function buildWhy (p, f, t, i, o, v, ctx, s = '') {
  const field = `${p}${f}`
  const gof = o == null ? go.fields[field] : o
  const exv = v == null ? 4 : v

  const srv = {}
  if (p !== '' || s !== '') {
    srv.why = `${f}${s}`
    srv.detail = `${f}Detail${s}`
  }

  return [
    tools.cfg.list(
      field, t, gof, {
        sel: i, ctx: ctx, srv: srv.why
      }
    ),
    tools.cfg.text(
      `${field}Detail`, 'Préciser', {
        sel: tools.equals(field, exv),
        srv: srv.detail
      }
    )
  ]
}

const whyNCAuditedOutfit = {
  p1p3: buildWhy(
    '', fields.whyNCAuditedOutfit,
    `Pourquoi la tenue de l'opérateur n'est-elle pas conforme ?`,
    tools.allTrue(
      select.p1p3,
      tools.oneTrue(
        select.no(sterileGown.p1.field),
        select.no(auditedCap.p1p3.field),
        select.no(compliantAuditedCap.p1p3.field),
        select.no(auditedMask.p1p3b2.field),
        select.no(compliantAuditedMask.p1p3b2.field),
        select.no(auditedCleanOutfit.p2p3b1b2.field)
      )
    ),
    go.fields.whyNCAuditedOutfit
  )
}

const whyNotAuditedMask = {
  b2: buildWhy(
    '', fields.whyNotAuditedMask,
    `Pourquoi l'opérateur ne porte-il pas de masque chirurgical ?`,
    tools.allTrue(select.b2, select.no(auditedMask.p1p3b2.field)),
    go.fields.whyNCAuditedOutfit
  )
}

const whyNCPatientOutfit = {
  p3b2: buildWhy(
    '', fields.whyNCPatientOutfit,
    `Pourquoi la tenue du patient n'est-elle pas conforme ?`,
    tools.allTrue(
      select.p3b2,
      tools.oneTrue(
        select.no(patientCleanOutfit.p1p2p3b2.field),
        select.no(compliantPatientMask.p1p3b2.field),
        select.no(patientOtherSide.p3b2.field)
      )
    ),
    go.fields.whyNCPatientOutfit
  )
}

function buildNotAlcool (prefix, v, i, p) {
  const asqPrefix = `${p}Antiseptic`
  const asqOtherPrefix = `${asqPrefix}Other`

  const isAlcoolic = (d) => {
    const a = d[asqPrefix]
    if (v.indexOf(a) !== -1) {
      return true
    }

    if (a !== 10) {
      return false
    }

    const ap = d[asqOtherPrefix]
    return ap == null || ap.match(/alcoolique/i) == null
  }

  Object.defineProperty(
    isAlcoolic, 'name', {
      value: `([${v}].indexOf(${asqPrefix}) !== -1 || (${asqPrefix} === 10 && ${asqOtherPrefix}.match(/alcoolique/i))`
    }
  )

  return buildWhy(
    prefix, fields.whyNotAlcool,
    `Pour un patient adulte, pourquoi l'antiseptique utilisé n'est-il pas un antiseptique alcoolique majeur ?`,
    tools.allTrue(
      i,
      isAlcoolic
    ),
    go.fields.whyNotAlcool
  )
}

const whyNotAlcool = {
  p1p2p3: buildNotAlcool(
    '', [1, 4, 6, 9], tools.oneTrue(
      tools.allTrue(select.p1p2p3, select.yes(isAdult.p1p2p3.field)),
      tools.allTrue(select.p4, patient.select.isAd)
    ),
    'p1p2p3p4'
  )
}

const whyNotHHC = {
  p1: buildWhy(
    '', fields.whyNotHHC,
    `Pourquoi la désinfection chirurgicale des mains par friction n'a-t-elle
       pas été réalisée ?`,
    tools.allTrue(
      select.p1,
      tools.oneTrue(
        select.no(handHygieneBeforeInsertion.p1[0].field),
        tools.equals(handHygieneBeforeInsertion.p1[1].field, 2)
      )
    ),
    go.fields.whyNotHHC
  )
}

const whyNotHH = {
  p2: buildWhy(
    '', fields.whyNotHH,
    `Pourquoi l'hygiène des mains n'a-t-elle pas été réalisée immédiatement avant l'insertion du
cathéter ?`,
    tools.allTrue(
      select.p2p4, select.no(handHygieneBeforePeriInsertion.p2[0].field)
    )
  )
}

const whyNotHHP = {
  p3: buildWhy(
    '', fields.whyNotHHP,
    `Pourquoi l'HDM n'a-t-elle pas été réalisée avant la ponction ?`,
    tools.allTrue(
      select.p3,
      select.no(handHygieneBeforePuncture.p3[0].field)
    ),
    go.fields2021.whyNotHHP,
    5
  )
}

const whyNotGloves = {
  p2: buildWhy(
    '', fields.whyNotGloves,
    `Pourquoi l'opérateur n'a-t-il pas porté de gants pour la pose du
cathéter ?`,
    tools.allTrue(
      select.p2p4,
      select.no(gloves.p2p3b1.field)
    )
  )
}

const whyNotHHM = {
  b1: buildWhy(
    'b1', fields.whyNotHHM, `Pourquoi l'HDM n'a-t-elle pas été réalisée avant la manipulation ?`,
    tools.allTrue(select.b1, select.no(handHygieneBeforeManip.b1[0].field)),
    go.fields.whyNotHHP, 5
  ),

  b2: buildWhy(
    'b2', fields.whyNotHHM, `Pourquoi l'HDM n'a-t-elle pas été réalisée avant la manipulation ?`,
    tools.allTrue(select.b2, select.no(handHygieneBeforeGloves.b2[0].field)),
    go.fields.whyNotHHP, 5
  )
}

const whyNotSterileCompresses = {
  b1: buildWhy(
    '', fields.whyNotSterileCompresses,
    `Pourquoi des compresses stériles n'ont-elles pas été utilisées ?`,
    tools.allTrue(select.b1, select.no(sterileCompresses.b1b2.field)),
    go.fields2020.whyNotSterileCompresses
  )
}
whyNotSterileCompresses.b1[0].convert.server = fields.whyNotCompresses
whyNotSterileCompresses.b1[1].convert.server = fields.whyNotCompressesDetail

const whyNotDisinfectValve = {
  b1b2: buildWhy(
    '', fields.whyNotDisinfectValve,
    `Pourquoi la valve n'a-t-elle pas été désinfectée ?`,
    tools.allTrue(select.b1b2, select.no(valveAntiseptic.b1b2[0].field))
  )
}

function buildTitle (
  text, start, hiddenWhenFieldIgnored = true, selector = null, type = 'observation'
) {
  return {
    text: text,
    start: start.field,
    hiddenWhenFieldIgnored,
    ignore: selector != null ? tools.not(selector) : undefined,
    type
  }
}

const old = [
  {
    text: `L'AUDITÉ`,
    start: audited.p1p3.field,
    hiddenWhenFieldIgnored: true,
    type: 'observation'
  },
  {
    text: `L'AUDITÉ`,
    start: audited.p2b1b2.field,
    hiddenWhenFieldIgnored: true,
    type: 'observation'
  },
  {
    text: 'LE PATIENT',
    start: isAdult.p1p2p3.field,
    type: 'observation',
    ignore: tools.not(select.p1p2p3b2)
  },
  {
    text: `PRÉPARATION DU SITE DE POSE DE L'AIGUILLE`,
    start: handHygieneBeforePreparation.p2p3[0].field,
    ignore: tools.not(select.p3),
    type: 'observation'
  },
  {
    text: `PRÉPARATION DU SITE D'INSERTION`,
    start: handHygieneBeforePreparation.p2p3[0].field,
    hiddenWhenFieldIgnored: false,
    ignore: tools.not(select.p1p2),
    type: 'observation'
  },
  {
    text: 'MANIPULATION',
    start: handHygieneBeforeManip.b1[0].field,
    type: 'observation',
    hiddenWhenFieldIgnored: true
  },
  {
    text: 'PRÉPARATION DU SITE DE BRANCHEMENT',
    start: handHygieneBeforeGloves.b2[0].field,
    type: 'observation',
    ignore: tools.not(select.b2),
    hiddenWhenFieldIgnored: true
  },
  {
    text: `POSE DU DISPOSITIF`,
    start: handHygieneBeforeInsertion.p1[0].field,
    ignore: tools.not(select.p1),
    type: 'observation'
  },
  {
    text: `INSERTION DU CATHÉTER`,
    start: handHygieneBeforePeriInsertion.p2[0].field,
    ignore: tools.not(select.p2),
    type: 'observation'
  },
  {
    text: `POSE DE L'AIGUILLE`,
    start: handHygieneBeforePuncture.p3[0].field,
    ignore: tools.not(select.p3),
    type: 'observation'
  },
  {
    text: `ENTRETIEN AVEC L'AUDITÉ`,
    start: whyNCAuditedOutfit.p1p3[0].field,
    type: 'observation',
    hiddenWhenFieldIgnored: false,
    ignore: tools.not(select.obs)
  }
]

const titles = {
  audited: (function () {
    const title = `L'AUDITÉ`
    return {
      p1p3: buildTitle(title, audited.p1p3),
      p2b1b2: buildTitle(title, audited.p2b1b2)
    }
  })(),

  patient: {
    p1p2p3b2: buildTitle(
      'LE PATIENT', isAdult.p1p2p3, false, select.p1p2p3b2
    )
  },

  insertionSite: {
    p1p2: buildTitle(
      `PRÉPARATION DU SITE D'INSERTION`, handHygieneBeforePreparation.p2p3[0],
      false, select.p1p2
    ),

    p3: buildTitle(
      `PRÉPARATION DU SITE DE POSE DE L'AIGUILLE`,
      handHygieneBeforePreparation.p2p3[0],
      false, select.p3
    )
  },

  manipulation: {
    b1: buildTitle('MANIPULATION', handHygieneBeforeManip.b1[0]),
    b2: buildTitle(
      'PRÉPARATION DU SITE DE BRANCHEMENT',
      handHygieneBeforeGloves.b2[0],
      true, select.b2
    )
  },

  insertion: {
    p1: buildTitle(
      `POSE DU DISPOSITIF`, handHygieneBeforeInsertion.p1[0],
      false, select.p1
    ),

    p2: buildTitle(
      `INSERTION DU CATHÉTER`, handHygieneBeforePeriInsertion.p2[0],
      false, select.p2
    ),

    p3: buildTitle(
      `POSE DE L'AIGUILLE`, handHygieneBeforePuncture.p3[0],
      false, select.p3
    )
  },

  interview: {
    all: buildTitle(
      `ENTRETIEN AVEC L'AUDITÉ`, whyNCAuditedOutfit.p1p3[0],
      false, select.obs
    )
  }
}

const sheet = {

  titles: [
    titles.audited.p1p3,
    titles.audited.p2b1b2,
    titles.patient.p1p2p3b2,
    titles.insertionSite.p3,
    titles.insertionSite.p1p2,
    titles.manipulation.b1,
    titles.manipulation.b2,
    titles.insertion.p1,
    titles.insertion.p2,
    titles.insertion.p3,
    titles.interview.all
  ],

  fields: [
    obsManagment.all,

    ...tools.addSelect(select.obs, [
      patient.sheetNumber.v2,
      tools.opts(patient.unitType.v1.rw, { sp: 'unitType' }),
      patient.uf
    ]),

    place.p1,
    otherPlace.p1,
    catheterType.p1,
    catheterType.p2,
    catheterType.b1,
    catheterType.b2,
    audited.p1p3,
    audited.p2b1b2,
    student.all,
    auditedCleanOutfit.p2p3b1b2,
    sterileGown.p1,
    auditedCap.p1p3,
    compliantAuditedCap.p1p3,
    sterileGloves.b2,
    auditedMask.p1p3b2,
    compliantAuditedMask.p1p3b2,
    isAdult.p1p2p3,
    childAge.p1p2p3,
    patientCleanOutfit.p1p2p3b2,
    patientMask.p1p3b2,
    compliantPatientMask.p1p3b2,
    patientSterileField.p1,
    patientOtherSide.p3b2,
    patientCap.p1,
    compliantPatientCap.p1,

    ...handHygieneBeforePreparation.p2p3,
    ...handHygieneBeforeManip.b1,
    ...handHygieneBeforeGloves.b2,

    dirtySkin.p1p2p3,
    insertionSiteCleaned.p1p2p3,
    ...antiseptic.p1p2p3,
    sterileCompresses.p1p2p3,
    sterileCompresses.b1b2,
    ...antiseptic.b1,
    ...antiseptic.b2,

    valve.b1b2,
    ...valveAntiseptic.b1b2,
    antisepticPassages.p1p2p3,
    dry.p1p2p3,

    ...handHygieneBeforeInsertion.p1,
    ...handHygieneBeforePeriInsertion.p2,
    ...handHygieneBeforePuncture.p3,

    sterileGloves.p1,
    gloves.p2p3b1,
    glovesType.p2p3,
    glovesJustified.b1,
    palpation.p2,

    ...whyNCAuditedOutfit.p1p3,
    ...whyNotAuditedMask.b2,
    ...whyNCPatientOutfit.p3b2,
    ...whyNotAlcool.p1p2p3,
    ...whyNotHHC.p1,
    ...whyNotHH.p2,
    ...whyNotHHP.p3,
    ...whyNotGloves.p2,
    ...whyNotHHM.b1,
    ...whyNotHHM.b2,
    ...whyNotSterileCompresses.b1,
    ...whyNotDisinfectValve.b1b2
  ],

  buildNotes: function (resultNotes, sheet) {
    checkAge(
      resultNotes, sheet, {
        unitType: patient.unitType.v1.rw.field,
        isAdult: result.fields.isAdult.p1p2p3.field,
        childAge: result.fields.childAge.p1p2p3.field
      }
    )
    return resultNotes
  }
}

for (let i = 0; i !== old.length; ++i) {
  const oldTitle = old[i]
  const newTitle = sheet.titles[i]

  assert.equals(oldTitle.text, newTitle.text, 'text')
  assert.equals(oldTitle.start, newTitle.start, 'start')
  assert.equals(!!oldTitle.hiddenWhenFieldIgnored, !!newTitle.hiddenWhenFieldIgnored, 'hidden')
  assert(!oldTitle.ignore || (oldTitle.ignore.name === newTitle.ignore.name), 'ignore')
  assert.equals(oldTitle.type, newTitle.type, 'type')
}

const result = ice.freeze({
  assertAllFieldsAreUsed: function (year) {
    for (let key in this.fields) {
      const fieldMap = this.fields[key]
      for (let sheets in fieldMap) {
        const item = fieldMap[sheets]

        if (rtti.isArray(item)) {
          for (let i = 0; i !== item.length; ++i) {
            const field = item[i]
            assert.notNull(field, `Undefined field ${key} ${i}`)
            assert(
              this.sheet.fields.find((s) => s != null && s.field === field.field),
              `${year}: Field defined but not found in sheet: ${key}[${i}] «${field.field}»`
            )
          }
          continue
        }

        assert(
          this.sheet.fields.find((s) => s != null && s.field === item.field),
          `${year}: Field defined but not found in sheet: ${key} «${item.field}»`
        )
      }
    }

    for (let key in this.titles) {
      const titleMap = this.titles[key]
      for (let sheets in titleMap) {
        const item = titleMap[sheets]

        assert(
          this.sheet.titles.find(
            (s) => s != null && s.text === item.text && s.start === item.start
          ),
          `${year}: Title defined but not found in title list: ${key}, «${item.text}» `
        )
      }
    }
  },

  select,

  build: {
    antiseptic: buildAntiseptic,
    why: buildWhy,
    notAlcool: buildNotAlcool,
    handHygiene: buildHandHygiene,
    title: buildTitle
  },

  titles,

  fields: {
    obsManagment,
    place,
    otherPlace,
    catheterType,
    audited,
    student,
    auditedCleanOutfit,
    sterileGown,
    auditedCap,
    compliantAuditedCap,
    sterileGloves,
    auditedMask,
    compliantAuditedMask,
    isAdult,
    childAge,
    patientCleanOutfit,
    patientMask,
    compliantPatientMask,
    patientSterileField,
    patientOtherSide,
    patientCap,
    compliantPatientCap,
    handHygieneBeforePreparation,
    handHygieneBeforeManip,
    handHygieneBeforeGloves,
    handHygieneBeforeInsertion,
    handHygieneBeforePeriInsertion,
    handHygieneBeforePuncture,
    dirtySkin,
    insertionSiteCleaned,
    antiseptic,
    sterileCompresses,
    valveAntiseptic,
    valve,
    antisepticPassages,
    dry,
    gloves,
    glovesType,
    glovesJustified,
    palpation,
    whyNCAuditedOutfit,
    whyNotAuditedMask,
    whyNCPatientOutfit,
    whyNotAlcool,
    whyNotHHC,
    whyNotHH,
    whyNotHHP,
    whyNotGloves,
    whyNotHHM,
    whyNotSterileCompresses,
    whyNotDisinfectValve
  },

  sheet
}, 10)

result.assertAllFieldsAreUsed('2020')
export default result
